import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

// MUI Theme
import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

// Services
import AuthService from '../../../services/auth.service';

// Utils
import { StyledItem } from '../../../utils/StyledItem';

// Redux
import { useAppSelector, useAppDispatch } from '../../../redux/hook';
import { fetchReaderReportById } from '../../../redux/slices/readerReportSlice';
import { fetchReaderByImei } from '../../../redux/slices/readerSlice';

// Types
import { FilterableTypes } from '../../../types/FilterableTypes';
import { AppPermissions } from '../../../constants/Permissions';

// Components
import ProcessSightings from '../sightings/processSightings';
import { ReportSummary } from './mobile/reportSummary';
import ShareReport from './components/ShareReport';

// Styles
import '../../../styles/muiTabs.scss';

export default function ReaderDetail(): JSX.Element {
  const { reportId } = useParams();
  const location = useLocation();

  const [activeBottomTab, setBottomActiveTab] = useState('1');
  const [totalCount, setTotalCount] = useState<number>(0);

  const source = location.state?.source;

  const readerReportState = useAppSelector((state) => state.readerReports);

  const dispatch = useAppDispatch();

  // lifecycle methods
  useEffect(() => {
    if (reportId) {
      dispatch(
        fetchReaderReportById({
          filters: [{ reportId: reportId, filterType: FilterableTypes.Equals }],
        } as any),
      );
    }
  }, [reportId]);

  useEffect(() => {
    if (readerReportState?.readerReport?.imei) {
      dispatch(fetchReaderByImei(readerReportState.readerReport.imei));
    }
  }, [readerReportState?.readerReport?.imei]);

  const handleTotalCountChange = useCallback((count: number) => {
    setTotalCount(count);
  }, []);

  const handleBottomTabchange = (event: React.SyntheticEvent, newValue: string) => {
    setBottomActiveTab(newValue);
  };

  return (
    <>
      {AuthService.hasPermission(AppPermissions.SightingProcessed.Read) && readerReportState.readerReport && (
        <div style={{ position: 'relative' }}>
          <ReportSummary report={readerReportState.readerReport} totalCount={totalCount} source={source} />
          {source === 'scanSessions' && <ShareReport report={readerReportState.readerReport} />}
        </div>
      )}

      <Grid container spacing={0.5} style={{ paddingTop: 5 }}>
        <Grid item xs={12}>
          <StyledItem>
            <TabContext value={activeBottomTab}>
              <div className='app-tabs'>
                <TabList onChange={handleBottomTabchange} aria-label='lab API tabs example'>
                  {AuthService.hasPermission(AppPermissions.SightingProcessed.Read) && (
                    <Tab label='Processed Sightings' value='1' sx={{ textTransform: 'none' }} />
                  )}
                </TabList>
              </div>

              {AuthService.hasPermission(AppPermissions.SightingProcessed.Read) && (
                <TabPanel value='1' style={{ height: '100vh', display: 'contents' }}>
                  {readerReportState.readerReport && <ProcessSightings showMap={true} onTotalCountChange={handleTotalCountChange} />}
                </TabPanel>
              )}
            </TabContext>
          </StyledItem>
        </Grid>
      </Grid>
    </>
  );
}
